import { useI18n } from "@wato/i18n/react";
import { Icon } from "@wato/ui";
import type { WorkspaceSummary } from "../../../api/types";
import { IconButton } from "../../../components/IconButton";
import { WorkspaceSwitcher } from "../../workspace-switcher/WorkspaceSwitcher";

/** OWN-320: workspace switcher + search at the top of the desktop sidebar (Ctrl+K stays). */
export function SidebarTop({
  workspaceId,
  workspaceName,
  workspaces,
  collapsed,
  onSearch,
}: {
  workspaceId: string;
  workspaceName: string;
  workspaces: readonly WorkspaceSummary[];
  collapsed: boolean;
  onSearch: () => void;
}) {
  const { t } = useI18n();
  return (
    <div
      data-testid="sidebar-top"
      className={`flex items-center gap-1 rounded-2xl bg-surface p-2 shadow-sm ${collapsed ? "flex-col" : "justify-between"}`}
    >
      <WorkspaceSwitcher
        currentId={workspaceId}
        currentName={workspaceName}
        workspaces={workspaces}
        compact={collapsed}
        placement="start-down"
      />
      <IconButton
        data-testid="sidebar-search"
        variant="ghost"
        label={t("command.open")}
        icon={<Icon name="search" size={18} />}
        onClick={onSearch}
      />
    </div>
  );
}
